import { AbstractCameraCaptureAdapter } from './AbstractCameraCaptureAdapter';
import { UnsupportedEnvironmentException } from '@ch-types/SeawardExceptions';
import { BatchPhotoCaptureConfig, BatchPhotoUploadResult } from '@services/camera/CameraTypes';

export class VelocityCameraCaptureAdapter extends AbstractCameraCaptureAdapter {
    public captureImage(_config: any): Promise<any> {
        return Promise.reject(new Error('Camera capture is not supported on Velocity browser'));
    }

    public captureImageAndUpload(_config: any): Promise<any> {
        return Promise.reject(new Error('Camera capture and upload is not supported on Velocity browser'));
    }

    /**
     * Rejects, as the single-photo methods above do — the Velocity browser has no camera bridge at
     * all.
     *
     * Note the different exception from `BatchCaptureNotImplementedException`, which an older host
     * frame raises across the bridge: this environment is unsupported, which is permanent, rather
     * than a bridge that exists but cannot serve batch yet. A caller can tell the two apart, and
     * `isBatchCaptureImplemented()` answers false here where it answers true on the cross-frame
     * path.
     *
     * @param _config - accepted and ignored.
     */
    public captureImagesAndUpload(_config: BatchPhotoCaptureConfig): Promise<BatchPhotoUploadResult> {
        return Promise.reject(
            new UnsupportedEnvironmentException({
                message: 'Batch photo capture and upload is not supported on Velocity browser',
            }),
        );
    }

    /**
     * Always false, permanently — there is no camera to batch-capture with here.
     */
    public isBatchCaptureImplemented(): boolean {
        return false;
    }
}
